module.exports = __webpack_public_path__ + "static/Hell_Hound-519a7a22a030a9de720c1c55c20e45c1.jpg";